import { DestroyRef, effect, inject, signal, Signal, WritableSignal } from '@angular/core';

export function debouncedSignal<T>(
    inputSignal: Signal<T>,
    debounceTime: number | Signal<number> = 0,
    outputSignal: WritableSignal<T> = signal(inputSignal())
): Signal<T> {
    const destroyRef = inject(DestroyRef);
    debounceTime = typeof debounceTime === 'number' ? signal(debounceTime) : debounceTime;

    const ref = effect(
        (onCleanup) => {
            const value = inputSignal();
            const timeout = setTimeout(
                () => {
                    outputSignal.set(value);
                },
                debounceTime()
            );

            onCleanup(() => {
                clearTimeout(timeout);
            });
        }, {
            manualCleanup: true
        }
    );

    destroyRef.onDestroy(() => ref.destroy());
    return outputSignal;
}
